import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as assistanceListings from '../../assistance-listings'

export const RESOURCE = {
  payload: {
    description:
      'A federal program that provides research funding and helps categorize funding sources. Find more at https://sam.gov/assistance-listings',
    dimension: assistanceListings.RESOURCE.payload,
    level: 0,
    name: 'Assistance Listing',
    partialId: PartialId.Standard.create('listing'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
